import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-34f349a9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "ant-row" }
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-17" }
const _hoisted_4 = { class: "ant-row" }
const _hoisted_5 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_6 = { class: "ant-col ant-col-xs-24 ant-col-xl-5" }
const _hoisted_7 = { class: "ant-col ant-col-xs-24 ant-col-xl-5" }
const _hoisted_8 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_9 = { class: "ant-row" }
const _hoisted_10 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_11 = { class: "ant-col ant-col-xs-24 ant-col-xl-7" }
const _hoisted_12 = { class: "ant-row" }
const _hoisted_13 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_14 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_15 = {
  key: 0,
  style: {"padding-top":"5px"}
}
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "ant-row" }
const _hoisted_18 = { class: "ant-col ant-col-xs-24 ant-col-xl-10" }
const _hoisted_19 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_20 = { class: "ant-col ant-col-xs-24 ant-col-xl-9" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Fechar", -1))
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Confirmar", -1))
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { class: "ant-row" }
const _hoisted_27 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_selecionar_conceito_precificacao = _resolveComponent("selecionar-conceito-precificacao")!
  const _component_selecionar_status = _resolveComponent("selecionar-status")!
  const _component_selecionar_forma_inclusao_itens = _resolveComponent("selecionar-forma-inclusao-itens")!
  const _component_selecionar_empresa = _resolveComponent("selecionar-empresa")!
  const _component_card = _resolveComponent("card")!
  const _component_selecionar_data = _resolveComponent("selecionar-data")!
  const _component_selecionar_tipo_custo = _resolveComponent("selecionar-tipo-custo")!
  const _component_campo_numerico = _resolveComponent("campo-numerico")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_tabela_preco_produtos = _resolveComponent("tabela-preco-produtos")!
  const _component_editor_html = _resolveComponent("editor-html")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_requisicao_modal = _resolveComponent("requisicao-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_modal, {
      keyboard: false,
      centered: "",
      width: 1340,
      visible: _ctx.modalBase.computedVisivel,
      "onUpdate:visible": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
      title: "Cadastro de Tabela de Preço",
      "wrap-class-name": "ss-modal-cadastros"
    }, {
      closeIcon: _withCtx(() => [
        _createVNode(_component_icone, { nome: "voltar" })
      ]),
      footer: _withCtx(() => [
        _withDirectives(_createElementVNode("div", null, [
          ((_ctx.props.operacao.tipoPermissaoDados === _ctx.EPermissaoDados.Incluir && _ctx.telaBase.permissaoDados.incluir)
              || (_ctx.props.operacao.tipoPermissaoDados === _ctx.EPermissaoDados.Visualizar && _ctx.telaBase.permissaoDados.alterar))
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("button", {
                  type: "button",
                  class: "ant-btn ant-btn-lg ant-btn-secondary",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.salvar(true)))
                }, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.modalBase.textoBotaoSalvarNovo), 1)
                ]),
                _createElementVNode("button", {
                  type: "button",
                  class: "ant-btn ant-btn-lg ant-btn-primary ss-btn-acao-destaque",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.salvar(false)))
                }, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.modalBase.textoBotaoSalvar), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ], 512), [
          [_vShow, _ctx.state.requerSalvarDadosPrincipais]
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_skeleton, {
          loading: _ctx.telaBase.carregando,
          paragraph: { rows: 15 }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form, { layout: "vertical" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_component_card, { titulo: "DADOS PRINCIPAIS" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_4, [
                          _createElementVNode("div", _hoisted_5, [
                            _createVNode(_component_a_form_item, {
                              label: "Descrição",
                              class: "ss-margin-campos",
                              rules: [{ required: true }]
                            }, {
                              default: _withCtx(() => [
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  maxlength: "250",
                                  class: "ant-input",
                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.tabelaPreco.descricao) = $event)),
                                  onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.requerSalvarDadosPrincipais && _ctx.requerSalvarDadosPrincipais(...args)))
                                }, null, 544), [
                                  [_vModelText, _ctx.state.tabelaPreco.descricao]
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_6, [
                            _createVNode(_component_a_form_item, {
                              label: "Conceito precificação",
                              class: "ss-margin-campos",
                              rules: [{ required: true }]
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_selecionar_conceito_precificacao, {
                                  codigoSelecionado: _ctx.state.tabelaPreco.conceitoPrecificacao,
                                  "onUpdate:codigoSelecionado": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.tabelaPreco.conceitoPrecificacao) = $event)),
                                  onChange: _ctx.requerSalvarDadosPrincipais,
                                  disabled: true
                                }, null, 8, ["codigoSelecionado", "onChange"])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_7, [
                            _createVNode(_component_a_form_item, {
                              label: "Status da tabela",
                              class: "ss-margin-campos",
                              rules: [{ required: true }]
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_selecionar_status, {
                                  codigoSelecionado: _ctx.state.tabelaPreco.status,
                                  "onUpdate:codigoSelecionado": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.tabelaPreco.status) = $event)),
                                  onChange: _ctx.requerSalvarDadosPrincipais
                                }, null, 8, ["codigoSelecionado", "onChange"])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_8, [
                            _createVNode(_component_a_form_item, {
                              label: "Novos itens serão adicionados como?",
                              class: "ss-margin-campos",
                              rules: [{ required: true }]
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_selecionar_forma_inclusao_itens, {
                                  codigoSelecionado: _ctx.state.tabelaPreco.formaInclusaoItens,
                                  "onUpdate:codigoSelecionado": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.tabelaPreco.formaInclusaoItens) = $event)),
                                  onChange: _ctx.requerSalvarDadosPrincipais
                                }, null, 8, ["codigoSelecionado", "onChange"])
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _withDirectives(_createElementVNode("div", _hoisted_9, [
                          _createElementVNode("div", _hoisted_10, [
                            _createVNode(_component_a_form_item, {
                              label: "Empresas",
                              class: "ss-margin-campos",
                              rules: [{ required: true }]
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_selecionar_empresa, {
                                  varias: true,
                                  empresasEspecificas: _ctx.telaBase.empresasDisponiveis,
                                  codigosSelecionados: _ctx.telaBase.empresasSelecionadas,
                                  "onUpdate:codigosSelecionados": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.telaBase.empresasSelecionadas) = $event)),
                                  onChange: _ctx.requerSalvarDadosPrincipais
                                }, null, 8, ["empresasEspecificas", "codigosSelecionados", "onChange"])
                              ]),
                              _: 1
                            })
                          ])
                        ], 512), [
                          [_vShow, _ctx.telaBase.apresentarEmpresas]
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_card, {
                      titulo: "VALIDADE DOS PREÇOS",
                      style: {"margin-left":"5px"}
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("div", _hoisted_13, [
                            _createVNode(_component_a_form_item, {
                              label: "Data e Hora - Início",
                              class: "ss-margin-campos",
                              rules: [{ required: true }]
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_selecionar_data, {
                                  dataSelecionada: _ctx.state.tabelaPreco.dataValidadeInicio,
                                  "onUpdate:dataSelecionada": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.tabelaPreco.dataValidadeInicio) = $event)),
                                  horaMinuto: true,
                                  onChange: _ctx.requerSalvarDadosPrincipais
                                }, null, 8, ["dataSelecionada", "onChange"])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_14, [
                            _createVNode(_component_a_form_item, {
                              label: "Data e Hora - Fim",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_selecionar_data, {
                                  dataSelecionada: _ctx.state.tabelaPreco.dataValidadeFim,
                                  "onUpdate:dataSelecionada": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.tabelaPreco.dataValidadeFim) = $event)),
                                  horaMinuto: true,
                                  onChange: _ctx.requerSalvarDadosPrincipais
                                }, null, 8, ["dataSelecionada", "onChange"])
                              ]),
                              _: 1
                            })
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createVNode(_component_card, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_tabs, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_tab_pane, {
                          key: "0",
                          tab: "TIPOS DE PREÇO"
                        }, {
                          default: _withCtx(() => [
                            (_ctx.state.tiposPrecos.length > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                  _createVNode(_component_draggable, {
                                    modelValue: _ctx.state.tabelaPreco.estruturas,
                                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.state.tabelaPreco.estruturas) = $event)),
                                    "item-key": "codigoTipoPreco",
                                    handle: ".ss-mover",
                                    class: "ant-row",
                                    onChange: _cache[15] || (_cache[15] = ($event: any) => (_ctx.state.requerSalvarDadosPrincipais = true))
                                  }, {
                                    item: _withCtx(({ element, index }) => [
                                      (_openBlock(), _createElementBlock("div", {
                                        key: element.codigoTipoPreco,
                                        class: "ant-col ant-col-xs-24 ant-col-xl-8"
                                      }, [
                                        _createVNode(_component_card, {
                                          titulo: _ctx.obterDescricaoTipoPreco(element.codigoTipoPreco),
                                          moverCardTitulo: true,
                                          class: "ss-margin-campos"
                                        }, {
                                          AcoesExtra: _withCtx(() => [
                                            _createElementVNode("a", {
                                              style: {"float":"right"},
                                              class: "ss-icone",
                                              title: "Remover tipo de preço",
                                              onClick: ($event: any) => (_ctx.removerTipoPrecoEstrutura(index))
                                            }, [
                                              _createVNode(_component_icone, { nome: "excluir" })
                                            ], 8, _hoisted_16)
                                          ]),
                                          default: _withCtx(() => [
                                            _createElementVNode("div", _hoisted_17, [
                                              _createElementVNode("div", _hoisted_18, [
                                                _createVNode(_component_a_form_item, {
                                                  label: "Tipo de Custo",
                                                  class: "ss-margin-campos",
                                                  rules: [{ required: true }]
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_selecionar_tipo_custo, {
                                                      codigoSelecionado: element.codigoTipoCusto,
                                                      "onUpdate:codigoSelecionado": ($event: any) => ((element.codigoTipoCusto) = $event),
                                                      empresas: _ctx.telaBase.empresasSelecionadas,
                                                      limparSelecao: false,
                                                      onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.requerSalvarEstrutura()))
                                                    }, null, 8, ["codigoSelecionado", "onUpdate:codigoSelecionado", "empresas"])
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ]),
                                              _createElementVNode("div", _hoisted_19, [
                                                _createVNode(_component_a_form_item, {
                                                  label: "Markup",
                                                  class: "ss-margin-campos"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_campo_numerico, {
                                                      valor: element.markupPadrao,
                                                      "onUpdate:valor": ($event: any) => ((element.markupPadrao) = $event),
                                                      percentual: true,
                                                      onChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.requerSalvarEstrutura()))
                                                    }, null, 8, ["valor", "onUpdate:valor"])
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ]),
                                              _createElementVNode("div", _hoisted_20, [
                                                _createVNode(_component_a_form_item, {
                                                  label: "Desconto Máximo",
                                                  class: "ss-margin-campos"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_campo_numerico, {
                                                      valor: element.descontoMaximoPadrao,
                                                      "onUpdate:valor": ($event: any) => ((element.descontoMaximoPadrao) = $event),
                                                      percentual: true,
                                                      onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.requerSalvarEstrutura()))
                                                    }, null, 8, ["valor", "onUpdate:valor"])
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ])
                                            ])
                                          ]),
                                          _: 2
                                        }, 1032, ["titulo"])
                                      ]))
                                    ]),
                                    footer: _withCtx(() => [
                                      _createElementVNode("button", {
                                        type: "button",
                                        title: "Adicionar tipo de preço",
                                        class: "ant-btn ant-btn-secondary ss-tabela-preco-adicionar-tipo-preco",
                                        onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.prepararSelecaoTipoPreco && _ctx.prepararSelecaoTipoPreco(...args)))
                                      }, " + ")
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"])
                                ]))
                              : _createCommentVNode("", true),
                            _createVNode(_component_a_modal, {
                              keyboard: false,
                              centered: "",
                              visible: _ctx.state.apresentarSelecaoTipoPreco,
                              "onUpdate:visible": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.state.apresentarSelecaoTipoPreco) = $event)),
                              "wrap-class-name": "ss-modal-cadastros",
                              title: "Selecione o tipo de preço"
                            }, {
                              closeIcon: _withCtx(() => [
                                _createVNode(_component_icone, { nome: "voltar" })
                              ]),
                              footer: _withCtx(() => [
                                _createElementVNode("div", null, [
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "ant-btn ant-btn-secondary ant-btn-lg",
                                    onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.state.apresentarSelecaoTipoPreco = false))
                                  }, _hoisted_22),
                                  (_ctx.state.tiposPrecoSelecionados.length > 0)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        type: "button",
                                        class: "ant-btn ant-btn-lg ant-btn-primary ss-btn-acao-destaque",
                                        onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.adicionarTipoPreco && _ctx.adicionarTipoPreco(...args)))
                                      }, _hoisted_24))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              default: _withCtx(() => [
                                (_ctx.state.tiposPrecosSelecao.length <= 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                      _createVNode(_component_a_alert, {
                                        message: "Todos os preços já foram adicionados!",
                                        type: "info",
                                        "show-icon": ""
                                      })
                                    ]))
                                  : _createCommentVNode("", true),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.tiposPrecosSelecao, (tipoPreco) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: tipoPreco.codigo
                                  }, [
                                    _createVNode(_component_a_checkbox, {
                                      onChange: ($event: any) => (_ctx.manipulaTipoPrecosSelecionados($event, tipoPreco.codigo))
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(tipoPreco.descricao), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["onChange"])
                                  ]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["visible"])
                          ]),
                          _: 1
                        }),
                        (_ctx.estrategiaApresentarProdutos())
                          ? (_openBlock(), _createBlock(_component_a_tab_pane, {
                              key: "1",
                              tab: "PRODUTOS"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_card, { titulo: " " }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_tabela_preco_produtos, {
                                      codigoTabelaPreco: _ctx.state.tabelaPreco.codigo,
                                      tiposPrecos: _ctx.state.tiposPrecos,
                                      estruturas: _ctx.state.tabelaPreco.estruturas,
                                      empresas: _ctx.telaBase.empresasSelecionadas
                                    }, null, 8, ["codigoTabelaPreco", "tiposPrecos", "estruturas", "empresas"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        _createVNode(_component_a_tab_pane, {
                          key: "2",
                          tab: "OBSERVAÇÕES"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_26, [
                              _createElementVNode("div", _hoisted_27, [
                                _createVNode(_component_editor_html, {
                                  value: _ctx.state.tabelaPreco.observacoes,
                                  "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.state.tabelaPreco.observacoes) = $event)),
                                  onChange: _cache[20] || (_cache[20] = ($event: any) => (_ctx.requerSalvarDadosPrincipais()))
                                }, null, 8, ["value"])
                              ])
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["loading"]),
        _createVNode(_component_requisicao_modal, {
          visivel: _ctx.modalBase.exibirRequisicaoModal,
          "onUpdate:visivel": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.modalBase.exibirRequisicaoModal) = $event)),
          apresentarBarraProgresso: _ctx.modalBase.apresentarBarraProgresso,
          fraseBarraProgresso: _ctx.modalBase.fraseBarraProgresso,
          retornoRequisicao: _ctx.modalBase.retornoRequisicao
        }, null, 8, ["visivel", "apresentarBarraProgresso", "fraseBarraProgresso", "retornoRequisicao"])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}